import {GetAccountDefaults, GetAccountProperty, UpdateAccountProperty} from "@/utils/session-storage";

export function updateDataBeforeMount() {
    if (window.projectID && window.accountName) {
        UpdateAccountProperty(window.accountName, 'lastSelectedProjectId', window.projectID);
    }
}

export function getData() {
    let pathArr = location.pathname.split('/').filter(Boolean);
    let path = pathArr.length && pathArr[1] ? pathArr.join('/') : (pathArr.length && pathArr[0] ? pathArr[0] : undefined);
    let lastSelectedProjectId = GetAccountProperty(window.accountName, 'lastSelectedProjectId', GetAccountDefaults().lastSelectedProjectId);

    return {
        projectId: window.projectID,
        lastSelectedProjectId,
        path,
        accountName: window.accountName,
        isMainDomain: !window.accountName
    };
}
